import React, {useCallback, useRef, useState} from 'react'
import {Editor} from '@tiptap/react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import Popover from '@material-ui/core/Popover'
import WrapTextIcon from '@material-ui/icons/WrapText'
import {ImageWrap} from './extensions/ResizableImage'

const OPTIONS: {value: ImageWrap; label: string; description: string}[] = [
  {
    value: 'inline',
    label: 'In Line with Text',
    description: 'Image flows with text as a character',
  },
  {
    value: 'left',
    label: 'Left',
    description: 'Image floats left, text wraps on the right',
  },
  {
    value: 'right',
    label: 'Right',
    description: 'Image floats right, text wraps on the left',
  },
]

type ImageWrapButtonProps = {
  editor: Editor
}

export default function ImageWrapButton({editor}: ImageWrapButtonProps) {
  const [open, setOpen] = useState(false)
  const anchorRef = useRef<HTMLButtonElement>(null)

  const current: ImageWrap = editor.getAttributes('image').wrap || 'inline'

  const handleSelect = useCallback(
    (wrap: ImageWrap) => {
      editor.chain().focus().setImageWrap(wrap).run()
      setOpen(false)
    },
    [editor],
  )

  return (
    <>
      <Tooltip title="Wrap Text">
        <IconButton
          ref={anchorRef}
          size="small"
          onClick={() => setOpen((v) => !v)}
          color={open ? 'primary' : 'default'}
        >
          <WrapTextIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Popover
        open={open}
        anchorEl={anchorRef.current}
        onClose={() => setOpen(false)}
        anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
        transformOrigin={{vertical: 'top', horizontal: 'left'}}
        disableRestoreFocus
      >
        <div className="html-editor-image-wrap-menu">
          {OPTIONS.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className={`html-editor-image-wrap-menu__item${
                current === opt.value
                  ? ' html-editor-image-wrap-menu__item--active'
                  : ''
              }`}
              onClick={() => handleSelect(opt.value)}
            >
              <span className="html-editor-image-wrap-menu__label">
                {opt.label}
              </span>
              <span className="html-editor-image-wrap-menu__description">
                {opt.description}
              </span>
            </button>
          ))}
        </div>
      </Popover>
    </>
  )
}
